import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import styled from "@mui/material/styles/styled";

import { neutral } from "app/themes/colors";

/**
 * Header colours read CSS custom properties with the reports' look as the fallback, so a
 * surface can restyle every report header inside it by setting the variables on an
 * ancestor without touching the reports themselves. Administration does this through the
 * console theme (`app/themes/console.theme.ts` → `MuiTable`), which replaces black-on-grey
 * with the calmer console header (SN-19777 feedback).
 */
export const ReportTableCell = styled(TableCell)(() => ({
  [`&.${tableCellClasses.head}`]: {
    overflow: "hidden",
    pl: 1.5,
    fontWeight: "var(--report-table-head-weight, 700)",
    color: "var(--report-table-head-color, black)",
    whiteSpace: "normal",
    lineHeight: "normal",
    textTransform: "uppercase",
    letterSpacing: "var(--report-table-head-letter-spacing, 0.7px)",
    fontSize: "var(--report-table-head-font-size, 12px)",
    background: `var(--report-table-head-bg, ${neutral[100]})`
  },
  [`&.${tableCellClasses.sizeMedium}`]: {
    fontSize: "14px",
    "@media (max-width:1700px)": {
      fontSize: "13px"
    }
  }
}));
